import type { DeliveryOptionSelection } from "@/types/models/delivery.types";
import InformationRow, { InformationTd } from "../StyledComponents/InformationRow";

type Props = {
  selectedOptions?: DeliveryOptionSelection[];
};

function Options({ selectedOptions }: Props) {
  const optionsQuantity = selectedOptions?.length;

  return (
    <>
      {optionsQuantity ? (
        <tr>
          <InformationTd>Service optionnel</InformationTd>
          <InformationTd>
            {selectedOptions
              .map((opt) =>
                opt.clientPrice != null ? `${opt.name} (${opt.clientPrice} €)` : opt.name
              )
              .join(", ")}
          </InformationTd>
        </tr>
      ) : (
        <InformationRow title="Aucun service optionnel" value="" />
      )}
    </>
  );
}

export default Options;
